import BalanceUsageTab from './BalanceUsageTab'

// 用户使用情况：仅保留余额使用情况子页面（对话内容/技能点击/所有点击/视频生成/用量分析/超额使用已移除）
export default function UserUsageTab() {
  return <BalanceUsageTab />
}
